<script setup lang="ts">
import { useScreen } from "@/composable/useResponsive";
import { HEADER_HEIGHT, TABS_HEIGHT, FINDINGS_PANEL_WIDTH } from "./constants";
import { computed } from "vue";
import ReportState, { ReportSection } from "@/stores/report/ReportState";

const props = defineProps<{
  showDrawer?: boolean;
  title?: string;
}>();

const { screen } = useScreen();

const sideWidth = computed(() => {
  if (!props.showDrawer) return 0;
  if (screen.value.gt.xl) return 500;
  if (screen.value.gt.lg) return 400;
  if (screen.value.gt.md) return 200;
  return 0;
});

const templateId = computed(() => ReportState.activeTemplateId);
const isFindingsSection = computed(
  () => ReportState.activeSection === ReportSection.FINDINGS,
);

// Top offset: header + tabs (when template is selected)
const topOffset = computed(() => {
  return templateId.value ? HEADER_HEIGHT + TABS_HEIGHT : HEADER_HEIGHT;
});

// Left offset: findings panel width (only on findings section)
const leftOffset = computed(() => {
  return isFindingsSection.value ? FINDINGS_PANEL_WIDTH : 0;
});
</script>

<template>
  <div
    v-if="screen.lt.md"
    :style="`margin-left: ${leftOffset}px; margin-top: ${topOffset}px; margin-right: ${sideWidth}px`"
    class="text-center w-100 d-flex flex-column justify-content-center align-items-center"
  >
    <el-icon :size="48" class="mb-3"><i class="bi-phone" /></el-icon>

    <span class="fw-medium text-center">
      {{ $t("report:notAvailableMobile") }}</span
    >
  </div>

  <template v-else>
    <main
      class="flex-grow-1 overflow-auto p-5"
      :style="`margin-left: ${leftOffset}px; margin-top: ${topOffset}px; margin-right: ${sideWidth}px; z-index: 0; height: calc(100vh - ${topOffset}px)`"
    >
      <slot name="options"></slot>
      <div class="d-flex justify-content-center">
        <slot></slot>
      </div>
    </main>
  </template>
</template>

<style lang="scss" scoped></style>
